<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        type="text" @input="searchForm.userId = String(searchForm.userId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
        v-model="searchForm.userId"
        placeholder="请输入用户ID"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-input
        size="medium"
        v-model="searchForm.userName"
        placeholder="请输入真实姓名"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-input
        size="medium"
        v-model="searchForm.coinName"
        placeholder="请输入币种"
        @keyup.enter.native="getTableList"
      ></el-input>
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-date-picker
       size="medium"
        v-model="searchForm.start_time"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.end_time"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="id"
      width="280px"
      label="订单号">
    </el-table-column>
    <el-table-column
      prop="userId"
      label="用户编号">
    </el-table-column>
    <el-table-column
      prop="userName"
      width="80px"
      label="真实姓名">
    </el-table-column>
    <el-table-column
      prop="phone"
      width="120px"
      label="手机号">
    </el-table-column>
    <el-table-column
      prop="email"
      width="180px"
      label="邮箱">
    </el-table-column>
    <el-table-column
      prop="coinName"
      label="币种">
    </el-table-column>
    <el-table-column
      prop="linkName"
      label="链路">
    </el-table-column>
    <el-table-column
      width="400px"
      prop="to"
      label="充币地址">
    </el-table-column>
    <el-table-column
      label="充币数量">
      <template slot-scope="scope">
        <span>{{scope.row.value}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="state"
      label="充币状态">
      <template slot-scope="scope">
        <span>{{scope.row.state=='DONE'?"充币成功":scope.row.state=='PENDING'?'充币中':"充币失败"}}</span>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 30, 40]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.end_time;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.start_time;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        start_time:'',
        end_time:'',
        userId:'',
        userName:'',
        coinName:'',
        walletAddr:''
      },
      tableData: [],
      stateOptions: [
        { name: "全部", value: '' },
        { name: "待审核", value: 0 },
        { name: "审核通过", value: 1 },
        { name: "审核拒绝", value: 2 },
        { name: "已取消", value: 3 }
      ],
      userId: '',
      balance: 0,
      balanceTwo: 0,
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.listChargePage({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
